import React from "react";
import * as Constants from "../utils/constants";
import { RouteComponentProps } from "react-router-dom";
import HeaderNavBar from "../components/HeaderNavBar";
import { StaticContext } from "react-router";
import AppNavigationState from "../utils/AppNavigationState";
import { WithTranslationLangProps } from "../utils/i18next/with-translation-keys";
import { withTranslation } from "react-i18next";
import {
  getLocalisedContent,
  MarkdownStrContent,
} from "../utils/i18next/localised-content";
import ReactMarkdown from "react-markdown";
import remarkMath from 'remark-math';
import rehypeMathjax from 'rehype-mathjax/svg';
import remarkGfm from 'remark-gfm';

type RouterParams = { from: string; to: string; datetime: string };

interface IAboutPageProps
  extends WithTranslationLangProps,
    RouteComponentProps<
      RouterParams,
      StaticContext,
      AppNavigationState | undefined
    > {}

interface IAboutPageState {
  aProposContent: MarkdownStrContent | undefined;
  sourceDonneesContent: MarkdownStrContent | undefined;
  acronymesContent: MarkdownStrContent | undefined;
  definitionsContent: MarkdownStrContent | undefined;
  foncPreviseoContent1: MarkdownStrContent | undefined;
  foncPreviseoContent2: MarkdownStrContent | undefined;
  foncPreviseoContent3: MarkdownStrContent | undefined;
  foncPreviseoContent4: MarkdownStrContent | undefined;
  foncPreviseoContent5: MarkdownStrContent | undefined;
  foncOngletsContent: MarkdownStrContent | undefined;
  aProposArtContent: MarkdownStrContent | undefined;
}

class AboutPage extends React.Component<IAboutPageProps, IAboutPageState> {
  constructor(props: IAboutPageProps) {
    super(props);
    this.state = { 
      aProposContent: undefined,
      sourceDonneesContent: undefined,
      acronymesContent: undefined,
      definitionsContent: undefined,
      foncPreviseoContent1: undefined,
      foncPreviseoContent2: undefined,
      foncPreviseoContent3: undefined,
      foncPreviseoContent4: undefined,
      foncPreviseoContent5: undefined,
      foncOngletsContent: undefined,
      aProposArtContent: undefined,
    };
    this.updatePageContent = this.updatePageContent.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.componentDidUpdate = this.componentDidUpdate.bind(this);
  }

  updatePageContent() {
    if (this.props.i18n.resolvedLanguage !== undefined) {
      getLocalisedContent(Constants.CONTENT_PAGE_ABOUT_A_PROPOS, this.props.i18n).then(
        (result) => {
          this.setState({
            aProposContent: result,
          });
        }
      );
      getLocalisedContent(Constants.CONTENT_PAGE_ABOUT_SOURCE_DONNEES, this.props.i18n).then(
        (result) => {
          this.setState({
            sourceDonneesContent: result,
          });
        }
      );
      getLocalisedContent(Constants.CONTENT_PAGE_ABOUT_ACRONYMES, this.props.i18n).then(
        (result) => {
          this.setState({
            acronymesContent: result,
          });
        }
      );
      getLocalisedContent(Constants.CONTENT_PAGE_ABOUT_DEFINITIONS, this.props.i18n).then(
        (result) => {
          this.setState({
            definitionsContent: result,
          });
        }
      );
      getLocalisedContent(Constants.CONTENT_PAGE_ABOUT_FONC_PREVISEO_1, this.props.i18n).then(
        (result) => {
          this.setState({
            foncPreviseoContent1: result,
          });
        }
      );
      getLocalisedContent(Constants.CONTENT_PAGE_ABOUT_FONC_PREVISEO_2, this.props.i18n).then(
        (result) => {
          this.setState({
            foncPreviseoContent2: result,
          });
        }
      );
      getLocalisedContent(Constants.CONTENT_PAGE_ABOUT_FONC_PREVISEO_3, this.props.i18n).then(
        (result) => {
          this.setState({
            foncPreviseoContent3: result,
          });
        }
      );
      getLocalisedContent(Constants.CONTENT_PAGE_ABOUT_FONC_PREVISEO_4, this.props.i18n).then(
        (result) => {
          this.setState({
            foncPreviseoContent4: result,
          });
        }
      );
      getLocalisedContent(Constants.CONTENT_PAGE_ABOUT_FONC_PREVISEO_5, this.props.i18n).then(
        (result) => {
          this.setState({
            foncPreviseoContent5: result,
          });
        }
      );
      getLocalisedContent(Constants.CONTENT_PAGE_ABOUT_FONC_ONGLETS, this.props.i18n).then(
        (result) => {
          this.setState({
            foncOngletsContent: result,
          });
        }
      );
      getLocalisedContent(Constants.CONTENT_PAGE_ABOUT_A_PROPOS_ART, this.props.i18n).then(
        (result) => {
          this.setState({
            aProposArtContent: result,
          });
        }
      );
    }
  }

  componentDidMount() {
    if (this.props.i18n.resolvedLanguage !== this.state.aProposContent?.locale) {
      this.updatePageContent();
    }
  }

  componentDidUpdate(_prevProps: IAboutPageProps, _prevState: IAboutPageState) {
    if (
      _prevProps.t !== this.props.t ||
      this.props.i18n.resolvedLanguage !== this.state.aProposContent?.locale
    ) {
      this.updatePageContent();
    }
  }

  render() {
    return (
      <>
        <HeaderNavBar />
        <div className="container contents-table">
          <h6>{"Sommaire"}</h6>
          <ul>
            <li><a href="#a_propos" className="about-links">{"À propos"}</a></li>
            <li><a href="#source_donnees" className="about-links">{"Source des données"}</a></li>
            <li><a href="#acronymes" className="about-links">{"Acronymes"}</a></li>
            <li><a href="#definitions" className="about-links">{"Définitions"}</a></li>
            <li><a href="#fonc_previseo" className="about-links">{"Fonctionnement du modèle Previseo"}</a></li>
              <ol>
                <li><a href="#fonc_previseo_1" className="about-links">{"Que fournit le modèle Previseo ?"}</a></li>
                <li><a href="#fonc_previseo_2" className="about-links">{"Sur quelles données se base le modèle Previseo ?"}</a></li>
                <li><a href="#fonc_previseo_3" className="about-links">{"Comment fonctionne le modèle Previseo ?"}</a></li>
                <li><a href="#fonc_previseo_4" className="about-links">{"Quelle est la fiabilité du modèle Previseo ?"}</a></li>
                <li><a href="#fonc_previseo_5" className="about-links">{"Comment est déterminé le gradient de couleur ?"}</a></li>
              </ol>
            <li><a href="#fonc_onglets" className="about-links">{"Fonctionnement des onglets « Analyser mon trajet » et « Carte des taux de fiabilité »"}</a></li>
            <li><a href="#a_propos_art" className="about-links">{"À propos de l’Autorité de régulation des transports"}</a></li>
            </ul>
        </div>
        <div className="container a_propos">
          <h4 id="a_propos">{"À propos"}</h4>
          {this.state.aProposContent !== undefined && (
            <ReactMarkdown children={this.state.aProposContent.content}/>
          )}
        </div>
        <div className="container source_donnees">
          <h4 id="source_donnees">{"Source des données"}</h4>
            {this.state.sourceDonneesContent !== undefined && (
              <ReactMarkdown children={this.state.sourceDonneesContent.content}/>
            )}
        </div>
        <div className="container acronymes">
          <h4 id="acronymes">{"Acronymes"}</h4>
            {this.state.acronymesContent !== undefined && (
              <ReactMarkdown children={this.state.acronymesContent.content}/>
            )}
        </div>
        <div className="container definitions">
          <h4 id="definitions">{"Définitions"}</h4>
            {this.state.definitionsContent !== undefined && (
              <ReactMarkdown children={this.state.definitionsContent.content}/>
            )}
        </div>
        <div className="container fonc_previseo">
          <h4 id="fonc_previseo">{"Fonctionnement du modèle Previseo"}</h4>
            <br/><h5 id="fonc_previseo_1">{"1. Que fournit le modèle Previseo ?"}</h5>
              {this.state.foncPreviseoContent1 !== undefined && (
                <ReactMarkdown children={this.state.foncPreviseoContent1.content}/>
              )}
            <br/><h5 id="fonc_previseo_2">{"2. Sur quelles données se base le modèle Previseo ?"}</h5>
              {this.state.foncPreviseoContent2 !== undefined && (
                <ReactMarkdown children={this.state.foncPreviseoContent2.content}/>
              )}
            <br/><h5 id="fonc_previseo_3">{"3. Comment fonctionne le modèle Previseo ?"}</h5>
              {this.state.foncPreviseoContent3 !== undefined && (
                <ReactMarkdown
                  children={this.state.foncPreviseoContent3.content}
                  remarkPlugins={[remarkMath, remarkGfm]}
                  rehypePlugins={[rehypeMathjax]}
                />
              )}
            <br/><h5 id="fonc_previseo_4">{"4. Quelle est la fiabilité du modèle Previseo ?"}</h5>
              {this.state.foncPreviseoContent4 !== undefined && (
                <ReactMarkdown
                  children={this.state.foncPreviseoContent4.content}
                  remarkPlugins={[remarkGfm]}
                />
              )}
            <br/><h5 id="fonc_previseo_5">{"5. Comment est déterminé le gradient de couleur ?"}</h5>
              {this.state.foncPreviseoContent5 !== undefined && (
                <ReactMarkdown
                  children={this.state.foncPreviseoContent5.content}
                  remarkPlugins={[remarkGfm]}
                />
              )}
        </div>
        <div className="container fonc_onglets">
          <h4 id="fonc_onglets">{"Fonctionnement des onglets « Analyser mon trajet » et « Carte des taux de fiabilité »"}</h4>
            {this.state.foncOngletsContent !== undefined && (
              <ReactMarkdown children={this.state.foncOngletsContent.content}/>
            )}
        </div>
        <div className="container a_propos_art">
          <h4 id="a_propos_art">{"À propos de l’Autorité de régulation des transports"}</h4>
            {this.state.aProposArtContent !== undefined && (
              <ReactMarkdown children={this.state.aProposArtContent.content}/>
            )}
        </div>
        <a
          href="#top"
          title="Aller en haut de la page"
          id="top-link"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 6" fill="currentcolor">
            <path d="M12 6H0l6-6z"></path>
          </svg>
        </a>
      </>
    );
  }
}

export default withTranslation()(AboutPage);
